module.exports = __webpack_public_path__ + "assets/1d8186295ef25500c6779784c469e12f.svg";